import type { SubscriptionEventFieldDef } from './field-catalog'
import { getSubscriptionEventFieldDefs } from './field-catalog'
import { getSubscriptionEventTemplate } from './constants'

export interface SubscriptionEventMemberContext {
  email: string
  userUuid: string
}

function coerceFieldValue (def: SubscriptionEventFieldDef, raw: string): unknown {
  const trimmed = String(raw ?? '').trim()
  if (!trimmed) {
    return undefined
  }
  if (def.inputType === 'boolean') {
    return trimmed === 'true'
  }
  if (def.inputType === 'number') {
    const num = Number(trimmed)
    return Number.isFinite(num) ? num : undefined
  }
  return trimmed
}

export interface EventLogMutationInput {
  eventName: string
  data: Record<string, unknown>
}

/**
 * GraphQL EventLogInput for subscription QA (PascalCase eventName, camelCase data).
 */
export function buildSubscriptionEventLogInput (
  templateId: string,
  fieldValues: Record<string, string>,
  member: SubscriptionEventMemberContext,
): EventLogMutationInput {
  const template = getSubscriptionEventTemplate(templateId)
  if (!template) {
    throw new Error(`Unknown subscription event template: ${templateId}`)
  }
  const defs = getSubscriptionEventFieldDefs(templateId)
  const data: Record<string, unknown> = {
    externalId: member.userUuid,
    email: member.email,
  }
  defs.forEach((def) => {
    const coerced = coerceFieldValue(def, fieldValues[def.key] ?? '')
    if (coerced !== undefined) {
      data[def.key] = coerced
    }
  })
  return {
    eventName: template.graphqlEventName,
    data,
  }
}
